import { HOW_IT_HELPS } from "../../data/content";
import { MEDIA } from "../../data/media";
import { Reveal } from "../../lib/motion";

export const HowItHelps = () => {
  return (
    <section className="py-24 lg:py-36 bg-cream-100" aria-labelledby="how-heading">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Reveal><p className="overline text-sage-dark mb-5">How counselling can help</p></Reveal>
            <Reveal delay={0.05}>
              <h2 id="how-heading" className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.05] tracking-tight">
                It's not about being fixed.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-lg text-ink-soft leading-relaxed">
                It's about feeling a little lighter, and a little more understood. In our
                sessions I'll give you room to breathe — and gently help you find your own
                way forward.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-10 overflow-hidden rounded-3xl shadow-soft">
                <img
                  src={MEDIA.interior}
                  alt="Ffyona's counselling room in Swindon"
                  loading="lazy"
                  className="w-full h-80 object-cover object-center"
                />
              </div>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7 space-y-12 lg:space-y-16 lg:pt-6">
          {HOW_IT_HELPS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.05}>
              <div className="border-t border-sage/30 pt-8 flex gap-6 lg:gap-10" data-testid="how-chapter">
                <span className="font-serif text-4xl lg:text-5xl text-sage shrink-0">{c.n}</span>
                <div>
                  <h3 className="font-serif text-2xl lg:text-3xl text-ink">{c.title}</h3>
                  <p className="mt-3 text-lg text-ink-soft leading-relaxed">{c.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
